<template>
  <v-dialog class="pl-dialog" :max-width="maxWidth" :value="viewDialog">
    <v-card>
      <v-card-title class="pl-dialog__title">
        <h4>{{ title }}</h4>
      </v-card-title>
      <v-card-text v-html="message"> </v-card-text>
      <v-card-actions>
        <v-layout justify-end>
          <v-btn class="pl-btn pl-btn_default" @click="callback(false)">
            {{ cancelButtonTitle }}
          </v-btn>

          <v-btn color="primary" @click="callback(true)">
            {{ confirmButtonTitle }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    title: {
      type: String,
      default: 'Удаление',
    },
    message: {
      type: String,
      default: '',
    },
    viewDialog: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 400,
    },
    callback: {
      type: Function,
      required: true,
    },
    cancelButtonTitle: {
      type: String,
      default: 'Отмена',
    },
    confirmButtonTitle: {
      type: String,
      default: 'OK',
    },
  },
  watch: {
    viewDialog(newVal, oldVal) {
      if (newVal === false && oldVal === true) {
        this.callback(false)
      }
    },
  },
}
</script>
